import React, { useState, useEffect } from "react";
import {
  Select,
  Form,
  Input,
  InputNumber,
  Row,
  Col,
  Upload,
  Button,
  Spin,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import { DeleteFilled, UploadOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { update } from "../../../store/features/product/productSlice";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";

const BasicDetails = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const productStoreDetails = useSelector((state) => state.product.product);
  const { Option } = Select;
  const [categoryList, setCategoryList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      (async () => {
        form.setFieldsValue({
          name: productStoreDetails.name,
          categoryId: productStoreDetails.categoryId,
        });

        if (productStoreDetails && productStoreDetails.variants.length > 0) {
          form.setFieldsValue({
            variants: productStoreDetails.variants,
          });
        }

        var data = await axios.get("/category-all").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) setCategoryList(data.data.data);

        data = await axios.post("/variant-attributes").catch((error) => {
          Helper.ErrorHanlder(error);
        });

        if (data && data.data) setVariantList(data.data.data);
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
    // eslint-disable-next-line
  }, []);

  const handleVarientChange = (input, option) => {
    dispatch(update({ variants: input, attributes: option }));
  };

  const ImageUpload = async ({ file, onSuccess }) => {
    const formData = new FormData();
    formData.append("image", file);
    setLoading(true);

    try {
      const { data } = await axios.post("web-image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (data && data?.files?.[0]) {
        const filename = data.files[0];

        setFileList((prev) => [...prev, filename]);

        onSuccess("ok");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddField = () => {
    setFields((prev) => [
      ...prev,
      {
        label: "",
        type: "text",
        required: true,
      },
    ]);
  };

  const handleInputChange = (index, value) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, label: value } : field
    );
    setFields(updatedFields);
  };

  const handleTypeChange = (index, value) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, type: value } : field
    );
    setFields(updatedFields);
  };

  const handleRequiredChange = (index, value) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, required: value } : field
    );
    setFields(updatedFields);
  };

  const handleRemoveField = (indexToRemove) => {
    const updatedFields = fields.filter((_, index) => index !== indexToRemove);
    setFields(updatedFields);
  };

  useEffect(() => {
    dispatch(update({ inputs: fields }));
  }, [fields]);

  useEffect(() => {
    dispatch(update({ images: fileList }));
  }, [fileList]);

  return (
    <div className="mt-4">
      <Form name="basic" form={form} layout={"vertical"} autoComplete="off">
        <Row gutter={12}>
          <Col md={6}>
            <Form.Item label="Name" name="name">
              <Input
                onChange={(e) => {
                  dispatch(update({ name: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={6}>
            <Form.Item
              label="Category"
              name="categoryId"
              rules={[
                {
                  required: true,
                  message: "Category is rquired",
                },
              ]}
            >
              <Select
                className="text-start"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                validatetrigger="onChange"
                onChange={(input) => {
                  dispatch(update({ categoryId: input }));
                }}
              >
                <Option value={""}>Select</Option>
                {categoryList.map((i) => (
                  <Option key={i.id} value={i.id}>
                    {i.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={productStoreDetails.variants.length == 0 ? 6 : 12}>
            <Form.Item className="text-start" label="variants" name="variants">
              <Select
                showSearch
                mode="multiple"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onChange={(input, option) => {
                  handleVarientChange(input, option);
                }}
              >
                {variantList.map((i) => (
                  <Option key={i.id} value={i.id} variant={i}>
                    {i.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {productStoreDetails.variants.length == 0 && (
            <>
              <Col md={3}>
                <Form.Item label="Price" name="price">
                  <InputNumber
                    className="w-100"
                    onChange={(input) => {
                      dispatch(update({ price: input }));
                    }}
                  />
                </Form.Item>
              </Col>
              <Col md={3}>
                <Form.Item label="Retail Price" name="webPrice">
                  <InputNumber
                    className="w-100"
                    onChange={(input) => {
                      dispatch(update({ webPrice: input }));
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col md={8}>
            <Form.Item label="Catalogue" name="catalogue">
              <Input
                className="w-100"
                onChange={(e) => {
                  dispatch(update({ catalogue: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={8}>
            <Form.Item label="Order Demo Video" name="demoVideo">
              <Input
                className="w-100"
                onChange={(e) => {
                  dispatch(update({ demoVideo: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={8}>
            <Form.Item label="Size Ref" name="sizeRef">
              <Input
                className="w-100"
                onChange={(e) => {
                  dispatch(update({ sizeRef: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={8}>
            <Form.Item label="Text For Catalogue" name="catalogueLabel">
              <Input
                className="w-100"
                onChange={(e) => {
                  dispatch(update({ catalogueLabel: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={8}>
            <Form.Item label="Text For Order Demo Video" name="howToOrderLabel">
              <Input
                className="w-100"
                onChange={(e) => {
                  dispatch(update({ howToOrderLabel: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={8}>
            <Form.Item label="Text For Size Ref" name="sizeRefLabel">
              <Input
                className="w-100"
                onChange={(e) => {
                  dispatch(update({ sizeRefLabel: e.target.value }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={10}>
            <Form.Item label="Courier Type" name="courierType">
              <Select
                className="text-start"
                optionFilterProp="children"
                defaultValue={"individual"}
                onChange={(input) => {
                  dispatch(update({ courierType: input }));
                }}
              >
                <Option value={"individual"}>Individual Qty</Option>
                <Option value={"all"}>All Qty</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col md={5}>
            <Form.Item label="Courier Amount" name="courierAmount">
              <InputNumber
                className="w-100"
                onChange={(input) => {
                  dispatch(update({ courierAmount: input }));
                }}
              />
            </Form.Item>
          </Col>
          <Col md={16}>
            <Form.Item label="Description" name="desc">
              <ReactQuill
                theme="snow"
                onChange={(value) => {
                  dispatch(update({ desc: value }));
                }}
              />
            </Form.Item>
            <div className="add-product-fields">
              <label>Fields Details</label>
              <Button type="primary" onClick={() => handleAddField()}>
                Add
              </Button>
            </div>
            {fields.map((val, index) => (
              <div
                key={index}
                style={{ margin: "20px 0", display: "flex", flexWrap: "wrap" }}
              >
                <Col md={12}>
                  <Input
                    value={val.label}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                  />
                </Col>
                <Col md={6} style={{ textAlign: "start" }}>
                  <Select
                    value={val.type}
                    style={{ width: "100%" }}
                    onChange={(value) => handleTypeChange(index, value)}
                    options={[
                      { value: "text", label: "Text" },
                      { value: "date", label: "Date" },
                      { value: "image", label: "Image" },
                    ]}
                  />
                </Col>
                <Col md={4} style={{ textAlign: "start" }}>
                  <Select
                    value={val.required}
                    style={{ width: "100%" }}
                    onChange={(value) => handleRequiredChange(index, value)}
                    options={[
                      { value: true, label: "Required" },
                      { value: false, label: "Optional" },
                    ]}
                  />
                </Col>
                <Col md={2}>
                  <DeleteFilled
                    style={{
                      color: "red",
                      fontSize: "18px",
                      cursor: "pointer",
                      marginTop: "5px",
                    }}
                    onClick={() => handleRemoveField(index)}
                  />
                </Col>
              </div>
            ))}
          </Col>
          <Col md={8}>
            <Form.Item label="Images">
              <div
                style={{
                  border: "1px dashed grey",
                  padding: " 30px 10px",
                  borderRadius: "2px",
                }}
              >
                <Spin spinning={loading}>
                  <Upload
                    customRequest={ImageUpload}
                    listType="picture"
                    multiple
                    name="image"
                    maxCount={3}
                    fileList={fileList.map((fileName, index) => ({
                      uid: `${index}`,
                      name: fileName,
                      status: "done",
                      url: `http://thecharmingtreasure.in:4000/uploads/${fileName}`,
                    }))}
                    onRemove={async (file) => {
                      try {
                        const filename = file.name;

                        await axios.post("/delete-image", { filename });

                        setFileList((prev) =>
                          prev.filter((name) => name !== filename)
                        );

                        return true;
                      } catch (error) {
                        alert("Failed to delete image");
                        return false;
                      }
                    }}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Spin>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default BasicDetails;
